import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, NgZone, OnDestroy, inject, input, output } from '@angular/core';

import PerfectScrollbar from 'perfect-scrollbar';

import { SideNav } from './sidenav.js';

@Component({
    selector: 'sidenav', // tslint:disable-line
    exportAs: 'sidenav',
    template: '<ng-content />',
    standalone: false
})
export class SidenavComponent implements AfterViewInit, OnDestroy {
    private el = inject(ElementRef);
    private zone = inject(NgZone);
    private ref = inject(ChangeDetectorRef);

    public sidenav: any;

    readonly orientation = input('vertical');
    readonly animate = input(true);
    readonly accordion = input(true);
    readonly closeChildren = input(false);
    readonly showDropdownOnHover = input(false);

    readonly onOpen = input<any>(undefined);
    readonly onOpened = input<any>(undefined);
    readonly onClose = input<any>(undefined);
    readonly onClosed = input<any>(undefined);

    readonly destroy = output<SidenavComponent>();

    @HostBinding('class.sidenav') hostClassMain = true;
    @HostBinding('class.sidenav-horizontal') hostClassHorizontal = false;
    @HostBinding('class.sidenav-vertical') hostClassVertical = false;

    constructor() {
        this.ref.detach();

        // Set host classes
        this.hostClassHorizontal = this.orientation() === 'horizontal';
        this.hostClassVertical = !this.hostClassHorizontal;
    }

    ngAfterViewInit(): void {
        this.zone.runOutsideAngular(() => {
            this.sidenav = new SideNav(
                this.el?.nativeElement,
                {
                    orientation: this.orientation(),
                    animate: this.animate(),
                    accordion: this.accordion(),
                    closeChildren: this.closeChildren(),
                    showDropdownOnHover: this.showDropdownOnHover(),

                    onOpen: this.onOpen(),
                    onOpened: this.onOpened(),
                    onClose: this.onClose(),
                    onClosed: this.onClosed(),
                },
                PerfectScrollbar,
            );
        });
    }

    ngOnDestroy(): void {
        this.destroy.emit(this);
        if (this.sidenav) {
            this.zone.runOutsideAngular(() => this.sidenav.destroy());
        }
        this.sidenav = null;
        this.el = null;
    }
}
